// Generated automatically by nearley, version unknown
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }

const moo = require("moo");
const lexer = moo.compile({
  space: {match: /\s+/, lineBreaks: true},
  number: /-?(?:[0-9]|[1-9][0-9]+)(?:\.[0-9]+)?(?:[eE][-+]?[0-9]+)?\b/,
  comment: /#[^\n]*/,
  '[': '[',
  ']': ']',
  assignment: /=[^\n]*/,
  // Leading underscores are disallowed in field names, while constant names have no explicit restrictions.
  // So we are more lenient in lexing here, and the validation steps below are more strict.
  // See: https://github.com/ros/genmsg/blob/7d8b6ce6f43b6e39ea8261125d270f2d3062356f/src/genmsg/msg_loader.py#L188-L238
  fieldOrType: /[a-zA-Z_][a-zA-Z0-9_]*(?:\/[a-zA-Z][a-zA-Z0-9_]*)?/,
});


function extend(objs) {
  return objs.reduce((r, p) => ({ ...r, ...p }), {});
}
var grammar = {
    Lexer: lexer,
    ParserRules: [
    {"name": "main$ebnf$1", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "boolType", "arrayType", "__", "field", "_", "main$ebnf$1", "simple"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$2", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "bigintType", "arrayType", "__", "field", "_", "main$ebnf$2", "simple"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$3", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "numericType", "arrayType", "__", "field", "_", "main$ebnf$3", "simple"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$4", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "stringType", "arrayType", "__", "field", "_", "main$ebnf$4", "simple"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$5", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$5", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "timeType", "arrayType", "__", "field", "_", "main$ebnf$5", "simple"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$6", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$6", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "customType", "arrayType", "__", "field", "_", "main$ebnf$6", "complex"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$7", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$7", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "boolType", "__", "constantField", "_", "boolConstantValue", "_", "main$ebnf$7"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$8", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$8", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "bigintType", "__", "constantField", "_", "bigintConstantValue", "_", "main$ebnf$8"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$9", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$9", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "numericType", "__", "constantField", "_", "numericConstantValue", "_", "main$ebnf$9"], "postprocess": function(d) { return extend(d) }},
    {"name": "main$ebnf$10", "symbols": ["comment"], "postprocess": id},
    {"name": "main$ebnf$10", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["_", "stringType", "__", "constantField", "_", "stringConstantValue", "_", "main$ebnf$10"], "postprocess": function(d) { return extend(d) }},
    {"name": "main", "symbols": ["comment"], "postprocess": function(d) { return null }},
    {"name": "main", "symbols": ["blankLine"], "postprocess": function(d) { return null }},
    {"name": "boolType", "symbols": [{"literal":"bool"}], "postprocess": function(d) { return { type: d[0].value } }},
    {"name": "bigintType$subexpression$1", "symbols": [{"literal":"int64"}]},
    {"name": "bigintType$subexpression$1", "symbols": [{"literal":"uint64"}]},
    {"name": "bigintType", "symbols": ["bigintType$subexpression$1"], "postprocess": function(d) { return { type: d[0][0].value } }},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"byte"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"char"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"float32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"float64"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint32"}]},
    {"name": "numericType", "symbols": ["numericType$subexpression$1"], "postprocess": function(d) { return { type: d[0][0].value } }},
    {"name": "stringType", "symbols": [{"literal":"string"}], "postprocess": function(d) { return { type: d[0].value } }},
    {"name": "timeType$subexpression$1", "symbols": [{"literal":"time"}]},
    {"name": "timeType$subexpression$1", "symbols": [{"literal":"duration"}]},
    {"name": "timeType", "symbols": ["timeType$subexpression$1"], "postprocess": function(d) { return { type: d[0][0].value } }},
    {"name": "customType", "symbols": [(lexer.has("fieldOrType") ? {type: "fieldOrType"} : fieldOrType)], "postprocess":  function(d, _, reject) {
          const PRIMITIVE_TYPES = ["bool", "byte", "char", "float32", "float64", "int8", "uint8", "int16", "uint16", "int32", "uint32", "int64", "uint64", "string", "time", "duration"];
          const type = d[0].value;
          if (PRIMITIVE_TYPES.includes(type)) return reject;
          return { type };
        } },
    {"name": "arrayType", "symbols": [{"literal":"["}, "_", {"literal":"]"}], "postprocess": function(d) { return { isArray: true } }},
    {"name": "arrayType", "symbols": [{"literal":"["}, "_", "number", "_", {"literal":"]"}], "postprocess": function(d) { return { isArray: true, arrayLength: d[2] } }},
    {"name": "arrayType", "symbols": ["_"], "postprocess": function(d) { return { isArray: false } }},
    {"name": "field", "symbols": [(lexer.has("fieldOrType") ? {type: "fieldOrType"} : fieldOrType)], "postprocess":  function(d, _, reject) {
          const name = d[0].value;
          // Leading underscores or digits are not allowed in field names
          if (name.match(/^[a-zA-Z][a-zA-Z0-9_]*$/) == undefined) return reject;
          return { name };
        } },
    {"name": "constantField", "symbols": [(lexer.has("fieldOrType") ? {type: "fieldOrType"} : fieldOrType)], "postprocess":  function(d, _, reject) {
          const name = d[0].value;
          // Leading digits are not allowed in constant names (the ROS genmsg parser
          // allows them, but loading the generated Python code fails later)
          if (name.match(/^[a-zA-Z_][a-zA-Z0-9_]*$/) == undefined) return reject;
          return { name, isConstant: true };
        } },
    {"name": "boolConstantValue", "symbols": ["assignment"], "postprocess":  function(d, _, reject) {
          const valueText = d[0].split("#")[0].trim();
          if (valueText === "True" || valueText === "1") return { value: true, valueText };
          if (valueText === "False" || valueText === "0") return { value: false, valueText };
          return reject;
        } },
    {"name": "numericConstantValue", "symbols": ["assignment"], "postprocess":  function(d, _, reject) {
          const valueText = d[0].split("#")[0].trim();
          const value = parseFloat(valueText);
          return !isNaN(value) ? { value, valueText } : reject;
        } },
    {"name": "bigintConstantValue", "symbols": ["assignment"], "postprocess":  function(d, _, reject) {
          const valueText = d[0].split("#")[0].trim();
          try {
            const value = BigInt(valueText);
            return { value, valueText };
          } catch {
            return reject;
          }
        } },
    {"name": "stringConstantValue", "symbols": ["assignment"], "postprocess": function(d) { return { value: d[0], valueText: d[0] } }},
    {"name": "bool$subexpression$1", "symbols": [{"literal":"True"}]},
    {"name": "bool$subexpression$1", "symbols": [{"literal":"1"}]},
    {"name": "bool", "symbols": ["bool$subexpression$1"], "postprocess": function(d) { return true }},
    {"name": "bool$subexpression$2", "symbols": [{"literal":"False"}]},
    {"name": "bool$subexpression$2", "symbols": [{"literal":"0"}]},
    {"name": "bool", "symbols": ["bool$subexpression$2"], "postprocess": function(d) { return false }},
    {"name": "number", "symbols": [(lexer.has("number") ? {type: "number"} : number)], "postprocess": function(d) { return parseFloat(d[0].value) }},
    {"name": "assignment", "symbols": [(lexer.has("assignment") ? {type: "assignment"} : assignment)], "postprocess": function(d) { return d[0].value.substr(1).trim() }},
    {"name": "comment", "symbols": [(lexer.has("comment") ? {type: "comment"} : comment)], "postprocess": function(d) { return null }},
    {"name": "blankLine", "symbols": ["_"], "postprocess": function(d) { return null }},
    {"name": "_$subexpression$1", "symbols": []},
    {"name": "_$subexpression$1", "symbols": [(lexer.has("space") ? {type: "space"} : space)]},
    {"name": "_", "symbols": ["_$subexpression$1"], "postprocess": function(d) { return null }},
    {"name": "__", "symbols": [(lexer.has("space") ? {type: "space"} : space)], "postprocess": function(d) { return null }},
    {"name": "simple", "symbols": [], "postprocess": function() { return { isComplex: false } }},
    {"name": "complex", "symbols": [], "postprocess": function() { return { isComplex: true } }}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();
